import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper } from 'lucide-react';
import { useNewsArticles } from '@/hooks/useNews';
import { NewsCard } from '@/components/news/NewsCard';
import { Skeleton } from '@/components/ui/skeleton';

export function CompactNewsSection() {
  const { data: articles = [], isLoading, isError } = useNewsArticles({ limit: 3 });

  return (
    <section className="container mx-auto px-4 pb-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded-lg bg-primary/10">
              <Newspaper className="h-4 w-4 text-primary" />
            </div>
            <h2 className="font-display text-lg font-semibold">Latest in AI</h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center text-sm font-medium text-primary hover:underline"
          >
            View All News <ArrowRight className="h-4 w-4 ml-1" />
          </Link>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="h-24 rounded-xl" />
            ))}
          </div>
        ) : articles.length === 0 ? (
          <div className="rounded-xl border border-border/60 p-4 flex items-center justify-between gap-4">
            <p className="text-sm text-muted-foreground">
              {isError ? 'News is temporarily unavailable.' : 'No news yet — check back soon.'}
            </p>
            <Link to="/news" className="text-sm font-medium text-primary hover:underline whitespace-nowrap">
              Go to News
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {articles.map((article) => (
              <NewsCard key={article.id} article={article} variant="compact" />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
